import { api } from '@utils'

import {
  GetAllCategoryResponse,
  GetAllCategoryParams,
  CategoryService
} from '.'

const getAllCategory = async (
  params: GetAllCategoryParams,
): Promise<GetAllCategoryResponse> => {
  const res = await api.get<GetAllCategoryResponse>('/master/store-category', { params })
  return res.data
}

export const categoryService: CategoryService = {
  getAllCategory
}
